import { useEffect, useState } from 'react';
import { DEBOUNCE_DURATION } from '../../constants';

export const useDebounce = (value: string) => {
  const [debouncedOptionGroupSearchTerm, setDebouncedOptionGroupSearchTerm] = useState<string>();

  useEffect(() => {
    const delayInputTimeoutId = setTimeout(() => {
      setDebouncedOptionGroupSearchTerm(value);
    }, DEBOUNCE_DURATION);
    return () => clearTimeout(delayInputTimeoutId);
  }, [value, DEBOUNCE_DURATION]);

  return debouncedOptionGroupSearchTerm;
};
